var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPrecoTarget && _vm.precoTarget)?_c('div',[_c('v-chip',{class:_vm.color,attrs:{"label":""}},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.precoTarget,'R$', _vm.produto.produto.cotacaoProduto.produto.casasDecimais))+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }